export const logoHeightPercentage = 0.8;
export const googleFont = 'Poppins';
export const FACEBOOK_PIXEL_ID = '755881004949718';
export const GOOGLE_ANALYTICS_ID = 'UA-172746276-1';
